










































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'Devicon',
  props: {
    language: String,
  },
});
